import React, {
  useCallback,
  useState,
  useRef,
  useImperativeHandle,
} from "react";
import chevronDownIcon from "src/assets/chevron_down.svg";
import Select, { components } from "react-select";
// import resolveConfig from "tailwindcss/resolveConfig";
// import tailwindConfig from "src/tailwind.config";
// const themeConfig = resolveConfig(tailwindConfig);

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        src={chevronDownIcon}
        className="w-4 h-2 object-cover"
        alt="dropdownIcon"
      />
    </components.DropdownIndicator>
  );
};

const IndicatorSeparator = (props) => null;

const customStyles = {
  control: (base, state) => {
    return {
      ...base,
      borderColor: "#EEEEEE",
      backgroundColor: "#F9F9F9",
      height: 48,
      borderRadius: "6px",
      "&:hover": {
        borderColor: "trans",
      },
      boxShadow: state.isFocused ? "0 0 0 2px var(--color-secondary)" : null,
    };
  },
  valueContainer: (base, state) => {
    return {
      ...base,
      padding: "2px 16px",
    };
  },
  singleValue: (base, state) => {
    return {
      ...base,
      marginLeft: 0,
      marginRight: 0,
    };
  },
  dropdownIndicator: (base, state) => {
    return {
      ...base,
      paddingLeft: 0,
      paddingRight: 16,
    };
  },
};

const Dropdown = React.memo(
  React.forwardRef((props, ref) => {
    const {
      placeholder,
      defaultValue,
      value,
      listValue,
      helperText,
      error,
      onChange,
      ...passProps
    } = props;

    // const [focus, setFocus] = useState(false);
    const selectRef = useRef();

    useImperativeHandle(ref, () => ({
      focus: () => {
        selectRef.current.focus();
      },
    }));

    // const _handleFocus = useCallback(() => {
    //   _doFocus(focus);
    // }, [focus]);

    // const _handleBlur = useCallback(() => {
    //   _doBlur(focus);
    // }, [focus]);

    // const _handleClickInputContainer = useCallback(() => {
    //   _doFocus(focus);
    //   selectRef.current.focus();
    // }, [focus]);

    // const _doFocus = (isFocus) => {
    //   if (!isFocus) {
    //     setFocus(true);
    //   }
    // };

    // const _doBlur = (isFocus) => {
    //   if (isFocus) {
    //     setFocus(false);
    //   }
    // };

    // const _handleChange = (e) => {
    //   if (onChange) {
    //     onChange(e);
    //   }
    // };

    // const _getInputBorderClassName = () => {
    //   if (error) return "border-error";
    //   return focus ? "border-secondary ring-1 ring-secondary" : "border-border";
    // };

    return (
      <div>
        <div className="text-sm leading-6 text-labelPlaceholder mb-2 font-medium">
          {placeholder}
        </div>
        {/* <div
          className={`${_getInputBorderClassName()} flex flex-row items-center border rounded-md bg-background px-4`}
          onClick={_handleClickInputContainer}
        >
          <select
            className="focus:outline-none appearance-none flex-1 bg-background text-base font-semibold text-label py-3"
            {...passProps}
            onFocus={_handleFocus}
            onBlur={_handleBlur}
            onChange={_handleChange}
            ref={selectRef}
          >
            {listValue.map((item) => (
              <option value={item.id} key={item.id} className="bg-white">
                {item.name}
              </option>
            ))}
          </select>
          <img
            src={chevronDownIcon}
            className="w-4 h-2 object-cover"
            alt="dropdownIcon"
          />
        </div> */}
        <Select
          defaultValue={listValue.find(({ value }) => value === defaultValue.value)}
          options={listValue}
          onChange={onChange}
          className={
            "focus:outline-none appearance-none flex-1 text-base font-semibold text-label"
          }
          components={{
            DropdownIndicator,
            IndicatorSeparator,
          }}
          styles={customStyles}
          placeholder={null}
          ref={selectRef}
          {...passProps}
        />
        {!!helperText && (
          <div
            className={`${
              error ? "text-error" : "text-labelHelper"
            } text-xs mt-2 font-normal`}
          >
            {helperText}
          </div>
        )}
      </div>
    );
  })
);

export const useDropdownValue = (defaultValue) => {
  const [value, setValue] = useState(defaultValue);
  const onChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);
  return [value, onChange];
};

export default Dropdown;
